import {BrowserRouter, Routes, Route, Navigate, useLocation} from 'react-router-dom';
import Experiences from "./Experiences";
import Experience from "./Experience";
import Layout from "./Layout";
import BookNow from "./checkout/BookNow";
import HealthScreening from "./checkout/HealthScreening";
import Account from "./account/Account";
import Booking from "./account/Booking";
import UpdateDetails from "./account/UpdateDetails";
import ChangePassword from "./account/ChangePassword";
import Wallet from "./account/Wallet";
import WalletCheckout from "./account/WalletCheckout";
import CreateAccount from "./checkout/CreateAccount";
import Confirm from "./checkout/Confirm";
import Checkout from "./checkout/Checkout";
import BundleBook from "./checkout/BundleBook";
import BundleConfirm from "./checkout/BundleConfirm";
import Login from "./Login";
import ExperiencesAdminRouter from "./admin/AdminRouter";
import LogOut from "../LogOut";
import {useContext, useEffect, useRef} from "react";
import AppContext from "../../context";
import { trackMetaEvent } from '../../utils/metaPixel';
import Contact from "./Contact";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";

function PageViewTracker() {
    const context = useContext(AppContext);
    const location = useLocation();
    const mountedRef = useRef(false);
    const pixelId = context.domain?.metaPixelEnabled ? context.domain?.metaPixelId : null;

    useEffect(() => {
        if (!pixelId) return;
        if (!mountedRef.current) { mountedRef.current = true; return; }
        trackMetaEvent({ pixelId, eventName: 'PageView' });
    }, [location.pathname, pixelId]);

    return null;
}

const ConfirmRedirect = () => {
    const location = useLocation();
    return <Navigate to={`../create-account${location.search}`} />;
};

const ExperiencesRouter = () => {
    const context = useContext(AppContext);

    return <BrowserRouter>
        <PageViewTracker />
        <Routes>
            <Route path="log-out" element={<LogOut />} />
            {context.user && context.user.admin ? <Route path="/admin/*" element={<ExperiencesAdminRouter />} /> : null }
            <Route path="" element={<Layout />}>
                {context.user && !context.user.admin ?
                    <>
                        <Route path="/account/bookings/:id" element={<Booking />} />
                        <Route path="/account/update-details" element={<UpdateDetails />} />
                        <Route path="/account/change-password" element={<ChangePassword />} />
                        <Route path="/account/wallet/checkout/:id" element={<WalletCheckout />} />
                        <Route path="/account/wallet" element={<Wallet />} />
                        <Route path="/account" element={<Account />} />
                    </>
                    : null
                }
                <Route path="/login" element={<Login />} />
                <Route path="/create-account" element={<CreateAccount />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route path="/:id/checkout" element={<Checkout />}>
                    <Route path="health-screening" element={<HealthScreening />} />
                    <Route path="book-now" element={<BookNow />} />
                    <Route path="book-bundle" element={<BundleBook />} />
                    <Route path="create-account" element={<CreateAccount />} />
                    {context.user ?
                        <Route path="confirm" element={<Confirm />} />
                    :
                        <Route path="confirm" element={<ConfirmRedirect />} />
                    }
                    {context.user ?
                        <Route path="bundle-confirm" element={<BundleConfirm />} />
                    :
                        <Route path="bundle-confirm" element={<ConfirmRedirect />} />
                    }
                    <Route path="" element={<Navigate to="book-now" />} />
                </Route>
                <Route path="/:id" element={<Experience />} />
                <Route path="/" element={<Experiences />}>
                    <Route path="contact" element={<Contact />} />
                </Route>
                <Route path="*" element={<Navigate to="/" />} />
            </Route>
        </Routes>
    </BrowserRouter>
}

export default ExperiencesRouter
